function create_cart_item(provider, parent_ident, content_type, ident, count, extend_info) {
	if ([provider, parent_ident, content_type].indexOf(undefined) !== -1) {
		alert("Něco je moc špatně :-/");
		return false;
	}

	var item = {
		"count": count,
		"provider": provider,
		"parent_ident": parent_ident,
		"content_type": content_type
	};
	if (ident) {
		item["ident"] = ident;
	}
	if (extend_info) {
		if (typeof (extend_info) == "object")
			var parsedInfo = extend_info;
		else
			var parsedInfo = parse_json_dataset(extend_info);
		if (!parent_ident || !parent_ident.toString().startsWith('pd') || !parent_ident.toString().startsWith('ps')) {
			delete parsedInfo["extend_info"];
		}
		item["extend_info"] = parsedInfo;
	}
	return item;
}

// Helper function to convert object to URL parameters
function objectToURLParams(obj) {
	const params = new URLSearchParams();
	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			params.append(key, obj[key]);
		}
	}
	return params.toString();
}

// Helper function to serialize object to URL encoded string
function serialize(obj) {
	var str = [];
	for (var p in obj) {
		if (obj.hasOwnProperty(p)) {
			str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
		}
	}
	return str.join("&");
}

function matches(el, selector) {
	return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
}

function clear_message(node) {
	node.innerHTML = "";
	node.classList.remove("alert");
	node.classList.remove("alert-danger");
	node.classList.remove("alert-success")
}

function closest(node, selector) {
	var found = null;
	for (; node && node.parentNode; node = node.parentNode) {
		if (matches(node, selector)) {
			found = node;
			break;
		}
	}
	return found;
}

function check_one_form_field(field) {
	// pozor tady to nebude fungovat pro checkboxy a selecty protože ty nemají value :-( => jquery
	var isMandatory = false;
	var mandatoryIf = (typeof (field.dataset) != 'undefined' && "mandatory_if" in field.dataset) ? field.dataset.mandatory_if : undefined;
	var checkIf = (typeof (field.dataset) != 'undefined' && "check_if" in field.dataset) ? field.dataset.check_if : undefined;
	var checkIfSelect = (typeof (field.dataset) != 'undefined' && "check_if_select" in field.dataset) ? field.dataset.check_if_select : undefined;
	if (
		typeof (mandatoryIf) !== 'undefined' &&
		typeof (field.form.elements[mandatoryIf]) !== 'undefined'
	) {
		if (
			typeof (checkIf) !== 'undefined' &&
			typeof (field.form.elements[checkIf]) !== 'undefined'
		) {
			// podmínka je potřeba odladit
			if (
				field.form.elements[checkIf].type == 'checkbox' ? field.form.elements[checkIf].checked : $(field.form.elements[checkIf]).val()
			) {
				isMandatory = true;
			} else {
				isMandatory = false;
			}
		} else {
			// podmínka je potřeba odladit
			if (
				field.form.elements[mandatoryIf].type == 'checkbox' ? field.form.elements[mandatoryIf].checked : $(field.form.elements[mandatoryIf]).val()
			) {
				isMandatory = true;
			} else {
				isMandatory = false;
			}
		}
	} else {
		var isMandatory = field.dataset.required;
		// pokud je povinný tak k zkontroluj že to není jen pokud něco jiného
		if (isMandatory && isMandatory === 'true') {
			isMandatory = true;
		} else {
			isMandatory = false;
			if (isMandatory && isMandatory !== 'false') {
				console.error("wrong field madatory definition", field);
			}
		}
	}
	var value = field.type == 'checkbox' ? field.checked : $(field).val();
	var isOK = false;

	var do_check = true;
	var checkOnlyIfSelect = field.dataset.check_only_if_select;
	if (typeof (checkIfSelect) !== 'undefined') {
		var f_vals = checkIfSelect.split('|');
		var f_name = f_vals.shift();
		if (typeof (f_vals) !== 'undefined' && typeof (field.form.elements[f_name]) !== 'undefined') {
			var f_v = field.form.elements[f_name].value;
			if (!f_vals.includes(f_v)) {
				do_check = false;
			}
		}
	}

	if (value) {
		if (do_check === false) {
			isOK = true;
		} else if (field.dataset.regexp) {
			try {
				var re = new RegExp(field.dataset.regexp);
				isOK = value.match(re);
			} catch (err) {
				console.error("Chyba konstrukce re ", field.dataset.regexp, err);
				isOK = false;
			};
		} else {
			isOK = true;
		}
	} else {
		if (isMandatory) {
			isOK = false;
		} else {
			isOK = true;
		}
	}

	if (isOK) {
		var formFirstFullAddressInput = document.querySelector('input[name=' + window.firstAddress + '_full_address]');
		// pokud je prazdna value a jedna se o cnc (naseptavane adresy), nenastavuju is-valid ve funkci unmark_invalid()
		if (!value && typeof (formFirstFullAddressInput) !== 'undefined' && document.body.contains(formFirstFullAddressInput)) {
			unmark_invalid(field, undefined, false);
		} else {
			unmark_invalid(field);
		}
	}
	else {
		mark_invalid(field);
	}
	return isOK;
}

var is_address_valid = function (form, address_type) {
	if (address_type !== 'facturation' && address_type !== 'shipping') {
		console.error("is_address_valid  dostala neznámý typ adresy", address_type)
		return false;
	}
	var isOK = true;
	// najdi mi fieldy adresy:
	for (var i = 0; i < form.elements.length; i++) {
		var field = form.elements[i];
		if (field.classList.contains('js-addres_type-' + address_type)) {
			var fieldOK = check_one_form_field(field);
			isOK = fieldOK && isOK;
		}
	}

	return isOK;
};

function checkinputs(form) {
	var valid = true;
	$('input[type="text"]', form).each(function () {
		// if ($(this).is(":visible")) {
		var eachValid = check_one_form_field(this);
		valid = valid && eachValid;
		// }
	});

	$('input[type="checkbox"]', form).each(function () {
		// if ($(this).is(":visible")) {
		var eachValid = check_one_form_field(this);
		valid = valid && eachValid;
		// }
	});

	return valid;
}

var is_password_valid = function (form) {
	if (typeof (form.elements["password_pass"]) === "undefined") {
		// pokud tam není tak je to OK a nekontroluji
		return true;
	}

	// pokud tam element "chci se registrovat" není pak tu registraci vyžaduji a je povinná
	if (
		typeof (form.elements["do_register"]) !== "undefined" &&
		!form.elements["do_register"].checked
	) {
		// pokud tam není je pole "chci se registrovat" a je nezaškrtnuté tak je to OK a nekontroluji
		return true;
	}

	var p1 = check_one_form_field(form.elements["password_pass"]);
	var p2 = check_one_form_field(form.elements["password_again"]);
	if (p1 && p2) {
		// oboje je zadáno => kontrola jestli jsou stejné
		if (form.elements["password_pass"].value != form.elements["password_again"].value) {
			// nesedí mi ty hesla mezi sebou
			mark_invalid(form.elements["password_again"]);
			return false;
		} else {
			// jsou stejná -  podmínka na délku a obsah musí být udělaná v reguláru
			return true;
		}
	} else {
		// něco je špatne
		return false;
	}
};

function mark_invalid(node, group_selector, dataset_text) {
	group_selector = typeof group_selector !== 'undefined' ? group_selector : "div.form-group";

	if (typeof node !== 'undefined') {
		node.classList.add("is-invalid");
		var wrap = closest(node, group_selector);
		if (wrap) {
			wrap.classList.remove("is-valid");
			wrap.classList.add("is-invalid");
			wrap.classList.add("has-error");
			if (
				node.tagName.toLowerCase() === "input" &&
				node.type === "checkbox"
			) {
				wrap.classList.add("alert");
				wrap.classList.add("alert-danger");
			}
		}
		if (dataset_text) {
			var text_target = node.parentNode.querySelector("small.invalid-feedback");
			if (text_target) {
				text_target.innerHTML = node.dataset[dataset_text];
			}
		}
		if (node.dataset.error) {
			node.placeholder = node.dataset.error;
		}
	} else {
		// console.log('neexistujici field ve formulari' + node);
	}
}

function mark_success(node, group_selector) {
	if (!node) {
		// console.log('neexistujici field ve formulari');
		return;
	}
	group_selector = typeof group_selector !== 'undefined' ? group_selector : "div.form-group";
	// TOOD: classy
	node.classList.add("is-invalid");
	closest(node, group_selector).classList.add("has-error");
}

function parse_json_dataset(source) {
	try {
		if (typeof (source) == "object")
			data = source
		else
			data = JSON.parse(atob(source));
	}
	catch (error) {
		data = {};
	}
	return data;
};


function show_message(node, message, type) {
	node.innerHTML = message;
	node.classList.add("alert");
	node.classList.add("alert-" + type);
}

function unmark_invalid(node, group_selector, mark_valid = true) {
	if (!node) {
		// console.log('neexistujici field ve formulari');
		return;
	}
	group_selector = typeof group_selector !== 'undefined' ? group_selector : "div.form-group";
	node.classList.remove("is-invalid");
	var wrapper = closest(node, group_selector);
	if (wrapper) {
		wrapper.classList.remove("has-error");
		if (!node.classList.contains('js--checkbox-alert'))
			wrapper.classList.remove("alert");
		wrapper.classList.remove("alert-danger");
		wrapper.classList.remove("is-invalid");
		if (mark_valid)
			wrapper.classList.add('is-valid');
	}
	if (node.dataset.placeholder) {
		node.placeholder = node.dataset.placeholder;
	}
}

function unmark_valid(node, group_selector) {
	if (!node) {
		// console.log('neexistujici field ve formulari');
		return;
	}
	group_selector = typeof group_selector !== 'undefined' ? group_selector : "div.form-group";
	node.classList.remove("is-valid");
	var wrapper = closest(node, group_selector);
	if (wrapper) {
		wrapper.classList.remove("is-valid");
	}
	if (node.dataset.placeholder) {
		node.placeholder = node.dataset.placeholder;
	}
}

function scrollToElement(element, offset) {
	if (element.length > 0) {
		$('html, body').animate({
			scrollTop: (element.offset().top + offset)
		}, 500);
	}
}

function stringify_json_dataset(data) {
	data = JSON.stringify(data);
	return btoa(fix_json_special_chars(data));
}

/**
 * https://stackoverflow.com/questions/31649362/json-stringify-and-unicode-characters
 * @param data
 * @returns {string}
 */
function fix_json_special_chars(data) {
	var str_data = "";
	var chr = "";
	for (var i = 0; i < data.length; i++) {
		if (data[i].match(/[^\x00-\x7F]/)) {
			chr = "\\u" + ("000" + data[i].charCodeAt(0).toString(16)).substr(-4);
		} else {
			chr = data[i];
		}
		str_data = str_data + chr;
	}
	return str_data;
}

function finalizeAsyncLoadFactory(params, elem) {
	return function (response, status, xhr) {
		$(elem).prev().remove();
		$(elem).removeClass("async--loading");
		var failed = true;
		if (status == "success" && response) {
			failed = false;
			if (params.template_type == "carousel" || params.template_type == "modal_carousel") {
				if (params.template_type == "modal_carousel") {
					setTimeout(function () {
						// zpozdeni kvuli problikavani pri nacteni polozek v modal related carouselu
						$(elem).find(".carousel__modal").owlCarousel(CAROUSEL_CONFIG[".carousel__modal"]);
					}, 200);
				} else {
					$(elem).find(".carousel__items").owlCarousel(CAROUSEL_CONFIG[".carousel__items"]);
				}
				$(elem).find('button.add-to-cart').bind('click', handleAddToCart);
				$(elem).find("button.remove-from-cart").bind('click', handleRemoveFromCart);
				if (typeof initializeBLazy === "function") {
					initializeBLazy();
				}
				// bind reader buttons
				if (typeof bindReaderButtons === "function") {
					bindReaderButtons();
				}
				// bind GTM
				try {
					bindGTMtrackClick(elem);
				} catch (err) {
					console.error("Chyba při bindGTMtrackClick v finalizeAsyncLoadFactory", err);
				}
				try {
					runTrackEvent(elem);
				} catch (err) {
					console.error("Chyba při runTrackEvent v finalizeAsyncLoadFactory", err);
				}
				try {
					runMeiroTrackEvent(elem);
				} catch (err) {
					console.error("Chyba při runMeiroTrackEvent v finalizeAsyncLoadFactory", err);
				}

				// bind switcher carouset to list
				if (typeof switchCarouselToList === "function") {
					switchCarouselToList();
				}
				// bind tooltiopy a preview
				// TODO: Vyčlenit do funkce?
				const tooltipTriggerList = document.querySelectorAll('[data-toggle="tooltip"]')
				const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
			}
		} else if (!response) {
			cnc_right_col_box = $(elem).closest('.js--hide-empty-box')
			if (cnc_right_col_box.length)
				cnc_right_col_box.hide();
		}
		if (failed) {
			var message = "";
			$(elem).find(".js__async_loader__message").text(message);
		}
	};
}




if (!String.prototype.startsWith) {
	Object.defineProperty(String.prototype, 'startsWith', {
		value: function (search, rawPos) {
			var pos = rawPos > 0 ? rawPos | 0 : 0;
			return this.substring(pos, pos + search.length) === search;
		}
	});
}

function format_price(price) {
	return lpad(parseFloat(price).toFixed(2), 0);
};

function lpad(n, width) {
	z = '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};


// Truncate description
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.js-desc-truncate').forEach(function (box) {
		const toggle = box.querySelector('.desc-toggle');
		if (!toggle) return;

		const toggleText = toggle.querySelector('.toggle-text');

		toggle.addEventListener('click', function () {
			const expanded = box.classList.contains('expanded');

			box.classList.toggle('expanded');
			toggle.setAttribute('aria-expanded', !expanded);
			toggleText.textContent = !expanded ? toggle.dataset.textLess : toggle.dataset.textMore;
		});
	});
});


// show/hide detail description
$(".js-desc").click(function () {
	if ($(this).parent('.description').hasClass('description--show')) {
		$(this).attr('aria-expanded', 'false');
		$(this).parent('.description').removeClass('description--show');
		$(this).parent('.description').find('.desc--hide').attr('aria-hidden', 'true');
		$(this).parent('.description').find('.desc--show').attr('aria-hidden', 'false');
	} else {
		$(this).parent('.description').addClass('description--show');
		$(this).attr('aria-expanded', 'true');
		$(this).parent('.description').find('.desc--hide').attr('aria-hidden', 'false');
		$(this).parent('.description').find('.desc--show').attr('aria-hidden', 'true');
	}
});


// description
$(window).on("load resize", function () {
	descriptionCrop();
});

function descriptionCrop() {
	var box_desc = $("#js-desc");
	var box_desc_height = box_desc.prop("scrollHeight"); // real height of box
	var box_crop_height = getComputedStyle(document.documentElement).getPropertyValue('--description-crop-height');
	var btn_desc = $("#js-desc-btn");

	if (box_desc_height != null && box_desc_height > box_crop_height) {
		box_desc.addClass('desc--crop');
		btn_desc.addClass('show');
	} else {
		box_desc.removeClass('desc--crop');
		btn_desc.removeClass('show');
	}
}

$("#js-desc-btn").click(function () {
	var box_desc = $("#js-desc");
	var btn_desc = $(this);
	box_desc.toggleClass('desc--open');
	btn_desc.toggleClass('is--open');
	if (btn_desc.hasClass('is--open')) {
		btn_desc.html('<span>Méně</span><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" class="link__icon icon--right"><path d="M11.293 8.293l-6 6a1 1 0 0 0 1.414 1.414L12 10.414l5.293 5.293a1 1 0 0 0 1.414-1.414l-6-6a1 1 0 0 0-1.414 0z"/></svg>');
	} else {
		btn_desc.html('<span>Více</span><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" class="link__icon icon--right"><path d="M6 8a1 1 0 0 0-.707 1.707l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0-1.414-1.414L12 13.586 6.707 8.293A1 1 0 0 0 6 8z"/></svg>');
	}
});


// promobox/card title crop
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.promobox__title-crop').forEach(function (el) {
		// Zobrazit tlačítko pouze pokud je text oříznutý
		if (el.scrollHeight > el.offsetHeight) {
			var btn = el.parentElement.querySelector('.promobox__title-toggle');
			if (btn) btn.classList.remove('d-none');
		}
	});

	document.querySelectorAll('.promobox__title-toggle').forEach(function (btn) {
		btn.addEventListener('click', function () {
			var targetId = btn.getAttribute('data-target');
			var target = document.getElementById(targetId);
			if (target) {
				target.classList.toggle('expanded');
				var expanded = target.classList.contains('expanded');
				btn.setAttribute('aria-expanded', expanded);
				var span = btn.querySelector('span');
				if (span) {
					span.textContent = expanded ? 'Méně' : 'Více';
				}
			}
		});
	});
});


// Player
function toggleAudio(button) {
	const audioPlayer = button.nextElementSibling;
	const playIcon = button.querySelector('.icon--play');
	const pauseIcon = button.querySelector('.icon--pause');
	const span = button.querySelector('span');

	if (audioPlayer.paused) {
		audioPlayer.play();
		playIcon.classList.add('d-none');
		pauseIcon.classList.remove('d-none');
		span.innerHTML = button.dataset.pausetext || 'Zastavit <br>ukázku';
		button.setAttribute('aria-label', button.dataset.pausearia || 'Zastavit ukázku');
	} else {
		audioPlayer.pause();
		playIcon.classList.remove('d-none');
		pauseIcon.classList.add('d-none');
		span.innerHTML = button.dataset.playtext || 'Přehrát <br>ukázku';
		button.setAttribute('aria-label', button.dataset.playaria || 'Přehrát ukázku');
	}
	if (audioPlayer.dataset.binded !== 'true') {
		// Reset na play ikonu když se audio dokončí
		audioPlayer.onended = function () {
			playIcon.classList.remove('d-none');
			pauseIcon.classList.add('d-none');
			span.innerHTML = button.dataset.playtext || 'Přehrát <br>ukázku';
			button.setAttribute('aria-label', button.dataset.playaria || 'Přehrát ukázku');
		};
		audioPlayer.dataset.binded = 'true';
	}
}
// End Player